import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import CircularProgress from '@material-ui/core/CircularProgress';

import { history } from "../../../shared/configure-store";
import TablePaginationActions from "../../presentational/table-pagination-actions";
import Api from "../../../libraries/api";
import AuthHelper from "../../../libraries/auth-helper";

class Regional extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showDialog: false,
            errors: {},
            orderBy: 'code',
            sortedBy: '',
            searchBy: '',
            rows: [],
            total: 0,
            perPage: 10,
            currentPage: 0,
            isManage: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Gudangemas - Regional';
        let profile = AuthHelper.getProfile();
        if (profile['map-menu']) {
            let roles = profile['map-menu'].map((o) => ({
                id: o.id,
                name: o.menu.name,
                isCreate: o.isCreate,
                isManage: o.isManage,
            }));


            // TODO: FIX PERMISSION TO REGIONAL
            let all = roles.filter(item => item.name === 'Customer');
            this.setState({ isManage: all.length > 0 ? all[0].isManage : false });
        }
        this.__fetchData(false);
    }

    __fetchData = (update) => {
        this.setState({ loading: true });
        const page = update ? 0 : this.state.currentPage;
        const params = {
            sort: [
                {
                    'column-name': this.state.orderBy,
                    'is-ascending': this.state.sortedBy === 'asc',
                },
            ],
            page: page,
            size: this.state.perPage,
            is_deleted: false,
        };

        if (this.state.searchBy) params.search = this.state.searchBy;

        Api.post('/region/master', params)
            .then((resp) => {
                const { status, data } = resp;
                if (status === 200) {
                    this.setState({
                        rows: data.content,
                        total: data.totalElements,
                        currentPage: data.number,
                        totalPages: data.totalPages,
                        loading: false
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch((err) => {
                this.setState({ errors: err, loading: false });
            });
    };

    handleSearch = () => this.__fetchData(true);

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.__fetchData(false);
        }
    };

    handleSort = (val) => {
        let sortedBy = this.state.sortedBy;
        if (val !== this.state.orderBy) {
            sortedBy = 'asc';
        } else {
            sortedBy = sortedBy === 'asc' ? 'desc' : 'asc';
        }
        this.setState({
            orderBy: val,
            sortedBy: sortedBy,
            loading: true
        }, () => {
            this.__fetchData(false);
        });
    };

    handleChange(e, prop) {
        this.setState({ [prop]: e.target.value });
    };

    showMessage = (status, message) => toast[status ? 'success' : 'error'](message, { position: toast.POSITION.BOTTOM_RIGHT });

    handleChangePage = (_, newPage) => {
        this.setState({ rows: [], currentPage: newPage, currentPageTable: newPage, loading: true }, () => this.__fetchData(false));
    };

    handleChangeRowsPerPage = (e) => {
        this.setState({ perPage: parseInt(e.target.value, 10), currentPage: 1, loading: true }, () => this.__fetchData(false));
    };

    handleGo = (link) => history.push(link);

    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Daftar Regional</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Daftar Regional</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12">
                    <div className="table-wrapper pb-0">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className='mb-0'>Daftar Regional</h2>
                            </div>
                        </div>
                        <div className="table-list row">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="clickable" onClick={() => this.handleSort('code')}>
                                            Kode Regional
                                            {this.state.orderBy === 'code' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('name')}>
                                            Nama
                                            {this.state.orderBy === 'name' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell>Keterangan</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.loading ? (
                                        <TableRow>
                                            <TableCell colSpan={6} align="center" className="py-5"><CircularProgress color="primary" /></TableCell>
                                        </TableRow>
                                    ) : (
                                        this.state.rows.length === 0 ? (
                                            <TableRow style={{ height: 33 * this.state.perPage }}>
                                                <TableCell colSpan={3} style={{ textAlign: 'center' }}>Data Regional Setup kosong</TableCell>
                                            </TableRow>
                                        ) : (
                                            this.state.rows.map(row => (
                                                <TableRow key={row.id}>
                                                    <TableCell>{row.code}</TableCell>
                                                    <TableCell>{row.name}</TableCell>
                                                    <TableCell>{row.description}</TableCell>
                                                    <TableCell className='action-menu'>
                                                        <button className="btn-icon"><i className="fas fa-ellipsis-v"> </i></button>
                                                        <div className='action-wrap'>
                                                            <Link to={`/regional/edit/${row.id}`} className="btn-icon mb-2">
                                                                <i className="fas fa-pencil-alt"> </i> Ubah
                                                            </Link>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50]}
                            component="div"
                            count={this.state.total}
                            rowsPerPage={this.state.perPage}
                            page={this.state.currentPage}
                            backIconButtonProps={{ 'aria-label': 'previous page' }}
                            nextIconButtonProps={{ 'aria-label': 'next page' }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </div>
                </div>
                <ToastContainer />
            </div>
        );
    }
}

export default Regional;